import React, { useRef } from "react";

const CoursesBrief = () => {
	return (
		<section className="courses-summary-area" id="details-section">
			<div className="one-line">Courses:</div>
			<div className="courses-brief">
				<div className="single-course">
					<h3> Dev Course </h3>
					<div>
						<h4>Course general details </h4>
						<ul>
							<li>Javascript Fundamentals</li>
							<li>HTML, CSS, Web Fundamentals</li>
							<li>Node, Express, DBs (Postgres, SQL)</li>
							<li>Testing, Software Engineering, Devops</li>
						</ul>
					</div>
					<div className="course-info">Cost: $14,300 (deposit + 3 instalments)</div>
					<div className="course-info">Length: 6-months</div>
					<div className="course-info">Start date: August 2024 (provisional)</div>
					<div className="course-info"> Max size: 12 students</div>
				</div>
				<div className="single-course">
					<h3> UX Design Course </h3>
					<div>
						<h4>Course general details </h4>
						<ul>
							<li>Learn about Research, Design, Prototyping, and Testing</li>
							<li>
								Leverage prior knowledge and develop your area of interest
							</li>
							<li>Complete a minimum of 3 projects for your portfolio</li>
							<li>Develop Curiosity, Empathy and Humility as a designer</li>
						</ul>
					</div>
					<div className="course-info">Cost: $14,300 (deposit + 3 instalments)</div>
					<div className="course-info">Length: 6-months</div>
					<div className="course-info">Start date: August 2024 (provisional)</div>
					<div className="course-info"> Max size: 12 students</div>
				</div>
			</div>
		</section>
	);
};

export default CoursesBrief;
